import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useTranslation } from "@/hooks/useTranslation";
import type { TeamLLMDTO } from "@shaarp/common";
import { Switch } from "../../ui/switch";
import { LLM_PROVIDER_LOGOS, type LLMProvider } from "./llm-provider-logos";

interface LLMModelCardHeaderProps {
  llm: TeamLLMDTO;
  providerId: string;
  onUpdateAvailability: (llm: TeamLLMDTO, available: boolean) => void;
}

export function LLMModelCardHeader({
  llm,
  providerId,
  onUpdateAvailability,
}: LLMModelCardHeaderProps) {
  const { t } = useTranslation();
  const providerLogo = LLM_PROVIDER_LOGOS[providerId as LLMProvider];

  const handleAvailabilityChange = (checked: boolean) => {
    onUpdateAvailability(llm, checked);
  };

  return (
    <div className="flex items-center px-6 pt-6 pb-2">
      {providerLogo && (
        <img src={providerLogo} alt={providerId} className="w-5 h-5 mr-3" />
      )}
      <div className="flex items-center flex-1 gap-2">
        <span className="text-base font-semibold leading-none tracking-tight">
          {llm.name}
        </span>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <span className="text-xs select-none text-muted-foreground cursor-help">
                {t("team.components.llmPermissions.included")}
              </span>
            </TooltipTrigger>
            <TooltipContent>
              <span className="text-xs">
                {t("team.components.llmPermissions.tooltip.included")}
              </span>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
      <div className="flex flex-col items-end gap-2">
        {llm.default ? (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <div>
                  <Switch
                    checked={llm.available}
                    onCheckedChange={handleAvailabilityChange}
                    disabled={llm.default}
                  />
                </div>
              </TooltipTrigger>
              <TooltipContent>
                <p className="text-sm">
                  {t(
                    "team.components.llmPermissions.tooltip.cannotDisableDefault"
                  )}
                </p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        ) : (
          <Switch
            checked={llm.available}
            onCheckedChange={handleAvailabilityChange}
          />
        )}
      </div>
    </div>
  );
}
